var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 18C1.53472 18 1.03322 17.7978 0.6205 17.3935C0.206834 16.9902 0 16.5 0 15.9231V13.8462H2.125V15.9231H14.875V13.8462H17V15.9231C17 16.5 16.7932 16.9902 16.3795 17.3935C15.9668 17.7978 15.4653 18 14.875 18H2.125ZM8.5 13.8462L2.83333 8.30769L4.33783 6.83723L7.4375 9.86539V0H9.5625V9.86539L12.6622 6.83723L14.1667 8.30769L8.5 13.8462Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file_download.b0bbd62a91357c5d605f41569baa3495.svg";
export { ForwardRef as ReactComponent };